import React from 'react';
import {
  Route,
  NavLink,
  HashRouter
} from "react-router-dom";
import PropTypes from 'prop-types';
import {Fragment} from "react";
import { positions, Provider } from "react-alert";
import { PulseLoader } from 'react-spinners';
import AlertTemplate from "react-alert-template-basic";
import eye from "./images/eye.png"
import eyeClose from "./images/eyeClose.png"
import PhoneForm from "./PhoneForm";
import LoginCode from "./loginCode";
import {enqueueSnackbar} from "notistack";
import Cookies from 'js-cookie';

class LoginForm extends React.Component {
  state = {
    username: '',
    password: '',
    type: 'password',
    showCodeModal: false,
    email: '',
    isCodeValid: false,
    verificationCode: '',
    isLoggingIn: false
  };

  handle_change = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(prevstate => {
      const newState = { ...prevstate };
      newState[name] = value;
      return newState;
    });
  };

  handleClick = () => {
    const newType = this.state.type === 'text' ? 'password' : 'text';
    this.setState({
      type: newType,
      showPasswordIcon: newType === 'text'
    });
  };

  closeCodeModal = () => {
    this.setState({
      showCodeModal: false,
      isCodeValid: false
    });
  };

  handleLoginSubmit = async (e) => {
    e.preventDefault();
    const csrftoken = Cookies.get('csrftoken');

    this.setState({ isLoggingIn: true });

    try {
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      const response = await fetch(`${API_ADDRESS}verify_credentials/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
        body: JSON.stringify({
          username: this.state.username,
          password: this.state.password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        const isAdmin = data.is_staff || data.is_superuser;

        if (isAdmin) {
          await this.props.handle_login(e, {
            username: this.state.username,
            password: this.state.password,
            is_staff: data.is_staff,
            is_superuser: data.is_superuser,
            isAdmin: isAdmin
          });

          this.setState({
            username: '',
            password: '',
            isLoggingIn: false
          });
        } else {
          this.setState({
            email: data.email,
            showCodeModal: true,
            isLoggingIn: false
          }, () => {
            this.sendVerificationCode(data.email);
          });
        }
      } else {
        enqueueSnackbar('Неверный логин или пароль', { variant: 'error' });
        this.setState({ isLoggingIn: false });
      }
    } catch (error) {
      console.error('Error:', error);
      enqueueSnackbar('Ошибка, обратитесь к администратору', { variant: 'error' });
      this.setState({ isLoggingIn: false });
    }
  };

  sendVerificationCode = async (email) => {
    const csrftoken = Cookies.get('csrftoken');
    try {
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      const response = await fetch(`${API_ADDRESS}login_code/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrftoken,
        },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      if (response.ok) {
        this.setState({ verificationCode: data.code });
      } else {
        enqueueSnackbar('Ошибка, не удалось отправить проверочный код', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error:', error);
      enqueueSnackbar('Ошибка, обратитесь к администратору', { variant: 'error' });
    }
  };

  verifyCode = async (inputCode) => {
    const fullCode = this.state.verificationCode;
    const actualCode = fullCode.substring(13, 18);

    if (inputCode === actualCode) {
      try {
        const loginData = {
          username: this.state.username,
          password: this.state.password,
          is_staff: false,
          is_superuser: false,
          isAdmin: false
        };

        const mockEvent = { preventDefault: () => {}, persist: () => {} };

        await this.props.handle_login(mockEvent, loginData);

        this.closeCodeModal();
        this.setState({
          username: '',
          password: '',
        });
      } catch (error) {
        console.error('Login failed:', error);
        enqueueSnackbar('Ошибка входа после проверки кода', { variant: 'error' });
      }
    } else {
      enqueueSnackbar('Неверный код подтверждения', { variant: 'error' });
    }
  };

  render() {
    const { showCodeModal, isCodeValid } = this.state;
    var esia_ok = false;
    if(window.location.href.includes("?code=")){
      esia_ok = true;
    }
    const options = {
      timeout: 2000,
      position: positions.TOP_CENTER,
      transition: 'scale'
    };

    async function loginESIA(){
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      const res = await fetch(`${API_ADDRESS}esia/`);
      const url = await res.json();
      window.location.href = url['url'];
    }

    return (
      <>
        <form onSubmit={this.handleLoginSubmit}>
          <div className="raw-1">
            <div className="box">
            </div>
          </div>
          <div className="raw">
            <div className="col-35">
            </div>
            <div className="col">
              <h3 className="text-center textLogin">Электронное голосование</h3>
              <div className="raw">
                <label htmlFor="username" className="radioText">Имя пользователя:</label><br/>
              </div>
              <div className="raw">
                <span>
                  <input
                    type="text"
                    className="login-input"
                    name="username"
                    defaultValue=""
                    value={this.state.username}
                    onChange={this.handle_change}
                  />
                </span>
              </div>
              <div className="raw">
                <label htmlFor="password" className="radioText">Пароль:</label><br/>
              </div>
              <div className="raw">
                <span>
                  <input
                    type={this.state.type}
                    className="login-input"
                    name="password"
                    value={this.state.password}
                    defaultValue=""
                    onChange={this.handle_change}
                  />
                </span>
                <div className="iconPassHolder" onClick={this.handleClick} style={{cursor: 'pointer'}}>
                  <img
                      className="iconPass img"
                      src={this.state.type === 'text' ? eyeClose : eye}
                      alt={this.state.type === 'text' ? 'Скрыть пароль' : 'Показать пароль'}
                  />
                </div>
              </div>
              <div className="raw">
                <div className="SubmitBttnLogin">
                  <Provider template={AlertTemplate} {...options}>
                    <Fragment>
                      <button type="submit" className="button-login" style={{marginRight: '-25px'}}>
                        {this.state.isLoggingIn ? (
                            <PulseLoader color="#d63636" size={8} />
                        ) : (
                            'Войти'
                        )}
                      </button>
                    </Fragment>
                  </Provider>
                </div>
              </div>
              <HashRouter>
                <li className="textLink" style={{marginLeft: '22px'}}>
                  <NavLink to="/password_change" className="textLink">Забыли пароль?</NavLink>
                </li>
                <Route path="/password_change" component={PhoneForm}/>
              </HashRouter>
            </div>
          </div>
        </form>
        {showCodeModal && (
          <div className="modal-overlay">
            <LoginCode
              isCodeValid={isCodeValid}
              verifyCode={this.verifyCode}
              onClose={this.closeCodeModal}
            />
          </div>
        )}
      </>
    );
  }
}

export default LoginForm;

LoginForm.propTypes = {
  handle_login: PropTypes.func.isRequired
};